import { render } from "./LiveRoom.vue?vue&type=template&id=53c7a6e6&scoped=true"
import script from "./LiveRoom.vue?vue&type=script&lang=js"
export * from "./LiveRoom.vue?vue&type=script&lang=js"

import "./LiveRoom.vue?vue&type=style&index=0&id=53c7a6e6&scoped=true&lang=css"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c7a6e6"]])

export default __exports__